import { createSelector } from '@ngrx/store';

import * as fromSelectedGiftingState from '../../reducers/gifting/gifting.reducer';
import * as fromFeature from '../../reducers/index';

export const selectGiftingState = createSelector(fromFeature.getGiftingState, (state) => state);

export const selectGiftingRecipient = createSelector(
  selectGiftingState,
  (state) => state.recipient,
);

export const selectJointGiftingApprovalStatus = createSelector(
  selectGiftingState,
  fromSelectedGiftingState.getJointGiftingApprovalStatus,
);

export const selectRecepientAnonymousGift = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientAnonymousGift,
);

export const selectRecepientDTCNumber = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientDTCNumber,
);

export const selectRecipientType = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientType,
);

export const selectRecipientFirm = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientFirm,
);

export const selectRecipientName = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientName,
);

export const selectRecipientAccountNumber = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientAccountNumber,
);

export const selectRecipientTransferAgentName = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientTransferAgentName,
);
export const selectRecipientStreetAddress = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientStreetAddress,
);
export const selectRecipientZipcode = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientZipcode,
);
export const selectRecipientCity = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientCity,
);
export const selectRecipientState = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientState,
);
export const selectRecipientSSN = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientSSN,
);
export const selectRecipientDateOfBirth = createSelector(
  selectGiftingRecipient,
  fromSelectedGiftingState.getRecipientDateOfBirth,
);

export const selectTotalGiftAmount = createSelector(
  selectGiftingState,
  fromSelectedGiftingState.getTotalGiftAmount,
);

export const selectGiftId = createSelector(selectGiftingState, fromSelectedGiftingState.getGiftId);

export const selectSignState = createSelector(
  selectGiftingState,
  fromSelectedGiftingState.getSignState,
);
